var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 600,
    height: 600
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M600,300c0,165.686-134.314,300-300,300C134.314,600,0,465.686,0,300 C0,134.314,134.314,0,300,0C465.686,0,600,134.314,600,300"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 600,
    height: 600
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#25F4EE",
    d: "M260.178,257.104v-16.286c-5.453-0.742-10.993-1.206-16.646-1.206 C175.415,239.611,120,295.028,120,363.145c0,41.794,20.881,78.778,52.737,101.144c-20.56-22.072-32.763-51.64-32.763-84.113 C139.974,313.037,193.408,258.664,260.178,257.104"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#25F4EE",
    d: "M263.095,436.94c30.391,0,55.537-24.522,56.665-54.644l0.256-268.587 l48.708,0.018l-0.075-0.404c-1.023-5.526-1.585-11.212-1.585-17.03h-67.115l-0.108,268.973 c-1.129,30.12-25.918,54.295-56.309,54.295c-9.445,0-18.34-2.361-26.17-6.482C227.616,427.29,244.271,436.94,263.095,436.94"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#25F4EE",
    d: "M460.437,205.422v-15.757c-18.745,0-36.205-5.573-50.848-15.12 C422.625,189.52,440.336,201.118,460.437,205.422"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FE2C55",
    d: "M409.589,174.545c-14.284-16.405-22.963-37.813-22.963-61.222h-18.285 C373.075,138.896,388.56,160.834,409.589,174.545"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FE2C55",
    d: "M243.532,306.215c-31.107,0-56.791,25.82-56.791,56.93 c0,21.662,12.664,40.484,30.621,49.935c-6.692-9.274-10.684-20.619-10.684-32.904c0-31.108,25.31-56.418,56.417-56.418 c5.807,0,11.378,0.958,16.647,2.608v-68.517c-5.453-0.742-10.993-1.207-16.647-1.207c-0.978,0-1.944,0.052-2.917,0.074 l-0.258,0.013l-0.182,51.864C254.469,306.942,249.339,306.215,243.532,306.215"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FE2C55",
    d: "M460.437,204.617l-0.313-0.061l-0.016,51.822 c-34.8,0-67.135-11.454-93.458-30.348l0.021,137.114c0,68.117-55.024,123.189-123.141,123.189c-26.323,0-50.73-7.96-70.795-22.046 c22.569,24.227,54.715,39.419,90.358,39.419c68.116,0,123.53-55.415,123.53-123.532V243.783 c26.324,18.894,58.574,30.027,93.374,30.027v-67.115C473.29,206.695,466.748,205.969,460.437,204.617"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M367.063,363.145V226.752c26.323,18.894,58.573,30.027,93.373,30.027v-52.162 c-20.101-4.303-37.81-15.098-50.848-30.073c-21.029-13.711-36.206-35.649-40.94-61.221h-49.137l-0.108,268.973 c-1.128,30.121-25.918,54.295-56.309,54.295c-18.823,0-35.479-9.302-45.733-23.513c-17.957-9.45-30.247-28.272-30.247-49.935 c0-31.109,25.31-56.418,56.417-56.418c5.807,0,11.377,0.957,16.647,2.607v-52.619c-66.77,1.56-120.615,56.322-120.615,123.459 c0,32.474,12.613,62.041,33.173,84.113c20.065,14.085,44.472,22.389,70.795,22.389 C311.647,486.677,367.063,431.262,367.063,363.145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.fa62cb5a6c65df03f063af38dc273a62.svg";
export { ForwardRef as ReactComponent };